export const toAnalyticsIdSegment = (value: string): string =>
  value.toLowerCase().replace(/\s+/g, "-");
